import React, { Component } from 'react';
import Slider from 'react-slick';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Arrow } from '../utils/icons';
import 'slick-carousel/slick/slick.css';

const SliderWrapper = styled.div`
  margin: 4rem 0;
  position: relative;
`;

const SliderGradient = styled.div`
  position: absolute;
  left: 0;
  width: 70px;
  height: 100%;
  z-index: 1;
  background: -moz-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
`;

const StyledStep = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-block;
`;

const SlideWrapper = styled.div`
  padding: 0 1rem;
`;

const Image = styled.img`
  max-width: 100%;
  width: 100%;
`;

const StyledArrow = styled(Arrow)`
  position: absolute;
  bottom: -2rem;
  cursor: pointer;

  ${props =>
    props.next &&
    css`
      right: 4rem;
    `};
  ${props =>
    props.prev &&
    css`
      transform: rotate(180deg);
      left: 4rem;
    `};
`;

const StyledImageText = styled.span`
  font-weight: 300;
  font-size: 0.875rem;
  margin-left: 0.5rem;
`;

const NextArrow = ({ onClick }) => {
  return <StyledArrow onClick={onClick} next={'true'} />;
};

const PrevArrow = ({ onClick }) => {
  return <StyledArrow onClick={onClick} prev={'true'} />;
};

export default class Carousel extends Component {
  renderSlides() {
    const { slides } = this.props;

    return slides.map((s, index) => {
      return (
        <SlideWrapper key={index}>
          <Image src={s.image.url} alt={s.image.title} />
          <div>
            <StyledStep>
              {`${index + 1}`.padStart(2, '0')}/
              {`${slides.length}`.padStart(2, '0')}
            </StyledStep>
            {s.image.caption && (
              <StyledImageText>{s.image.caption}</StyledImageText>
            )}
          </div>
        </SlideWrapper>
      );
    });
  }

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 3,
      centerMode: true,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
      ]
    };

    return (
      <SliderWrapper>
        <SliderGradient />
        <Slider {...settings}>{this.renderSlides()}</Slider>
      </SliderWrapper>
    );
  }
}

Carousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
      }).isRequired
    })
  )
};



// WEBPACK FOOTER //
// ./src/components/Carousel.js